import { render, staticRenderFns } from "./DiffComponent.vue?vue&type=template&id=3d6e930e&"
import script from "./DiffComponent.vue?vue&type=script&lang=js&"
export * from "./DiffComponent.vue?vue&type=script&lang=js&"
import style0 from "./DiffComponent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports